import { useCallback, useRef } from 'react'

// 70px top bar height + 25px padding
const TOP_BAR_OFFSET = 70 + 25

export function useScrollToSection(shouldScroll: boolean) {
  const hasScrolled = useRef(false)

  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      if (shouldScroll && node && !hasScrolled.current) {
        hasScrolled.current = true
        const target = node.parentElement ?? node
        const top = target.getBoundingClientRect().top + window.scrollY
        window.scrollTo({ top: top - TOP_BAR_OFFSET, behavior: 'smooth' })
      }
    },
    [shouldScroll]
  )

  return ref
}
